import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-amount",
  "use": "icon-amount-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-amount\"><defs><style type=\"text/css\"></style></defs><path d=\"M967.89390222 488.40135111C967.89162667 243.83374222 770.27555555 44.67484445 524.51555555 44.37560889V510.86222222h443.60476445c0.34247111-7.96444445-0.22641778-15.22232889-0.22641778-22.46087111z\" p-id=\"14885\" /><path d=\"M506.50453333 926.44010667c-218.42944 0.00910222-395.63832889-176.74695111-395.63036444-395.17525334C110.86848 330.55630222 260.55111111 165.12227555 453.97333333 139.54844445v-56.32455112C228.69333333 109.13223111 54.96718222 299.97511111 54.96718222 531.59253333c0 249.30417778 202.17059555 450.76138667 451.46908445 450.76593778C734.9248 982.35278222 923.79022222 812.37333333 953.72288 591.64444445H897.21742222c-29.47299555 190.00888889-193.15029333 334.80021333-390.71288889 334.79566222z\" p-id=\"14886\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/amount.svg
// module id = yTd3
// module chunks = 197